import type { AppSelectOption } from 'shared/UI/UIKit/Select';

export enum TableFilterFieldType {
  INPUT = 'input',
  SELECT = 'select',
  NUMBER = 'number',
  MULTI_SELECT = 'multiSelect',
}
export type TableFilterField = {
  key: string;
  name: string;
  label: string;
  type: TableFilterFieldType;
  placeholder?: string;
  options?: AppSelectOption[];
  isLoadableOptions?: boolean;
  loading?: boolean;
  min?: number;
  precision?: number;
  className?: string;
  dropdownClassName?: string;
  dropdownMatchSelectWidth?: boolean;
};
